import { useForm, Link } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import { Textarea } from '@/components/ui/textarea'
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import SettingsLayout from '@/layouts/SettingsLayout'
import { useOrgPath } from '@/lib/pathFor'

export default function CarriersNew() {
  const pathFor = useOrgPath()
  const { data, setData, post, processing } = useForm({
    name: '',
    code: '',
    contact_email: '',
    contact_phone: '',
    website: '',
    notes: '',
    active: true,
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(pathFor('/settings/carriers'))
  }

  return (
    <>
      <header className="flex h-14 items-center gap-3 border-b px-8">
        <Link href={pathFor('/settings/carriers')} className="text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-4 w-4" />
        </Link>
        <h1 className="text-sm font-semibold">New Carrier</h1>
      </header>

      <div className="max-w-md p-8">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name" className="text-xs">Name *</Label>
            <Input
              id="name"
              required
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              className="mt-1 h-9 text-[13px]"
            />
          </div>

          <div>
            <Label htmlFor="code" className="text-xs">SCAC Code *</Label>
            <Input
              id="code"
              required
              value={data.code}
              onChange={(e) => setData('code', e.target.value)}
              className="mt-1 h-9 text-[13px] font-mono"
              placeholder="e.g. HLCU"
            />
          </div>

          <div>
            <Label htmlFor="contact_email" className="text-xs">Contact Email</Label>
            <Input
              id="contact_email"
              type="email"
              value={data.contact_email}
              onChange={(e) => setData('contact_email', e.target.value)}
              className="mt-1 h-9 text-[13px]"
            />
          </div>

          <div>
            <Label htmlFor="contact_phone" className="text-xs">Contact Phone</Label>
            <Input
              id="contact_phone"
              value={data.contact_phone}
              onChange={(e) => setData('contact_phone', e.target.value)}
              className="mt-1 h-9 text-[13px]"
            />
          </div>

          <div>
            <Label htmlFor="website" className="text-xs">Website</Label>
            <Input
              id="website"
              value={data.website}
              onChange={(e) => setData('website', e.target.value)}
              className="mt-1 h-9 text-[13px]"
              placeholder="https://"
            />
          </div>

          <div>
            <Label htmlFor="notes" className="text-xs">Notes</Label>
            <Textarea
              id="notes"
              value={data.notes}
              onChange={(e) => setData('notes', e.target.value)}
              className="mt-1 text-[13px]"
              rows={3}
            />
          </div>

          <div className="flex items-center gap-2">
            <Checkbox
              id="active"
              checked={data.active}
              onCheckedChange={(checked) => setData('active', checked === true)}
            />
            <Label htmlFor="active" className="text-xs cursor-pointer">Active</Label>
          </div>

          <div className="flex gap-2 pt-2">
            <Button type="submit" size="sm" disabled={processing}>
              Create Carrier
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="cursor-pointer"
              onClick={() => window.history.back()}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

CarriersNew.layout = (page: React.ReactNode) => (
  <AuthenticatedLayout>
    <SettingsLayout>{page}</SettingsLayout>
  </AuthenticatedLayout>
)
